import { Flex, Image, Title } from "@qws-org/ui-kit";
import type { FC } from "react";

import type { MainBannerV2Props } from "../MainBannerV2";
import { MainBannerButtons } from "./MainBannerButtons";
import { MainBannerColumnItems } from "./MainBannerColumnItems";

export const Column: FC<MainBannerV2Props> = (props) => {
  const { getImageUrl, data } = props;
  return (
    <Flex
      as="section"
      flexDirection="column"
      justify="center"
      align="center"
      horizontalAlign="center"
      p={{ px: 16, pt: 32, pb: 16 }}
      md={{ p: { py: 40 }, minHeight: 798 }}
      maxWidth={1272}
    >
      {data.image?.id && (
        <Image
          m={{ mb: 24 }}
          maxWidth={500}
          value={getImageUrl(data.image.id, {
            format: "webp",
            height: 100,
          })}
          mdValue={getImageUrl(data.image.id, {
            format: "webp",
            height: 120,
          })}
          dValue={getImageUrl(data.image.id, {
            format: "webp",
            height: 192,
          })}
        />
      )}
      <Title
        as="h2"
        size="large"
        fontWeight="mobile.superbold"
        horizontalAlign="center"
        bg="text-accent-grad"
        m={{ mb: 14 }}
        md={{ m: { mb: 64 } }}
        className="bg-clip-text text-transparent"
      >
        {props.data?.title}
      </Title>

      <MainBannerColumnItems {...props} />

      <MainBannerButtons {...props} bannerVariant="column" />
    </Flex>
  );
};
